var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"header":"Create user"}}),_c('user-form',{ref:"form",attrs:{"user":{
      all_subscriptions: [],
      country: null,
      account: null,
      channels: [],
      permissions: [],
      all_roles: [],
      user_role: null,
      interests: null,
    },"alert-lists":[],"all-alert-lists":_vm.alertLists},on:{"save-success":_vm.saveComplete}}),_c('save-bar',{staticClass:"mb-4",attrs:{"show-delete":false},on:{"save":function($event){return _vm.$refs.form.save()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }